module.exports = __webpack_public_path__ + "img/green_047.5170c9e9.png";